'use client';

import { Skeleton } from '@/components/ui/skeleton';

export function ServiceSlotsLoader() {
  return (
    <div className="space-y-6">
      {/* Staff Selection Skeleton */}
      <div>
        <Skeleton className="h-6 w-32 mb-4" />
        <Skeleton className="h-12 w-full rounded-lg" />
      </div>

      {/* Date Selection Skeleton */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <Skeleton className="h-6 w-32" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-8" />
          </div>
        </div>
        <div className="grid grid-cols-7 gap-2">
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={i} className="h-16 w-full rounded-lg" />
          ))}
        </div>
      </div>

      {/* Time Selection Skeleton */}
      <div>
        <Skeleton className="h-6 w-32 mb-4" />
        <div className="grid grid-cols-4 gap-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-10 w-full rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  );
}
